import { render, staticRenderFns } from "./PsiFormLayoutSection.vue?vue&type=template&id=45b96bec&scoped=true&"
import script from "./PsiFormLayoutSection.vue?vue&type=script&lang=js&"
export * from "./PsiFormLayoutSection.vue?vue&type=script&lang=js&"
import style0 from "./PsiFormLayoutSection.vue?vue&type=style&index=0&id=45b96bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b96bec",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VCol,VIcon,VProgressLinear,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b96bec')) {
      api.createRecord('45b96bec', component.options)
    } else {
      api.reload('45b96bec', component.options)
    }
    module.hot.accept("./PsiFormLayoutSection.vue?vue&type=template&id=45b96bec&scoped=true&", function () {
      api.rerender('45b96bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/forms/PsiFormLayoutSection.vue"
export default component.exports